<rp-nav></rp-nav>
<div class="pb-12 px-3 sm:px-4 lg:px-6 h-auto mx-auto min-w-0 max-w-full">
  <router-outlet></router-outlet>
</div>
<new-user-leads></new-user-leads>
<rp-loader></rp-loader>
<call-hub></call-hub>
